export default __webpack_public_path__ + "static/media/completed.47af09da.svg";